<div class="card mb-5">
	<div class="card-header">
		<h3>Historial de Traslados</h3>
	</div>
	<div class="card-body">
		<div class="row mb-3">
			<div class="col form-group">
				<label for="warehouse" class="form-label">Bodega</label>
				<select name="warehouse" id="warehouse" class="form-select" (change)="changeFilter()" [(ngModel)]="warehouse">
					<option [ngValue]="null">Selecciona una bodega</option>
					<option *ngFor="let w of warehouses" [ngValue]="w.id">{{w.name}}</option>
				</select>
			</div>
			<div class="col form-group">
				<label for="startDate" class="form-label">Fecha Inicio</label>
				<input type="date" id="startDate" (change)="changeFilter()" [(ngModel)]="startDate"
					name="startDate" class="form-control">
			</div>
			<div class="col form-group">
				<label for="endDate" class="form-label">Fecha Final </label>
				<input type="date" id="endDate" max="{{todayDate | date:'yyyy-MM-dd'}}" (change)="changeFilter()"
					[(ngModel)]="endDate" name="endDate" class="form-control">
			</div>
			<div class="col-auto d-flex flex-column align-content-center" [appCheckPermission]="[5090]" [permissionType]="permissionType.ALL">
				<label for="check" class="form-label">Resumen</label>
				<div class="h-100 d-flex justify-content-center">
					<input
						type="checkbox"
						name="check"
						class="summary-check"
						[(ngModel)]="summaryToggle"
						(change)="changeFilter()"
					/>
				</div>
			</div>
		</div>

		<div class="row" *ngIf="!summaryToggle">
			<div class="col" id="list-container">
				<ng-container *ngIf="warehouse && startDate && endDate">
					<ng-container *ngIf="!gettingData">
						<div class="table-responsive mt-2" style="margin-bottom: 0;">
							<table class="table table-bordered" style="margin-bottom: 0;">
								<thead>
									<tr class="tr-middle title">
										<th>
											Documento
										</th>
										<th>
											Descripción
										</th>
										<th>
											Origen
										</th>
										<th>
											Destino
										</th>
										<th>
											Fecha Envio
										</th>
										<th>
											Fecha Recepción
										</th>
										<th>
											Fecha Esperada
										</th>
										<th [appCheckPermission]="[5090]" [permissionType]="permissionType.ALL">
											Costo
										</th>
										<th>
											Ejecutada
										</th>
										<th>
											Tipo
										</th>
										<th class="no-border-td">
	
										</th>
									</tr>
								</thead>
								<tbody>
									<ng-container *ngFor="let transfer of pagination.filter">
										<tr class="tr-middle" >
											<td>
												{{transfer.documentNumber}}
												<i *ngIf="!transfer.documentNumber"
													class="fa-solid fa-file-circle-question"></i>
											</td>
											<td>
												{{transfer.description}}
												<i *ngIf="!transfer.description" class="fa fa-comment-slash"></i>
											</td>
											<td>
												{{warehousesName[transfer.fromWarehouse]}}
											</td>
											<td>
												{{warehousesName[transfer.toWarehouse]}}
											</td>
											<td>
												{{transfer.issuedDate | date: 'dd/MM/YYYY'}}
											</td>
											<td>
												{{transfer.receptionDate | date: 'dd/MM/YYYY'}}
												<i *ngIf="!transfer.receptionDate" class="fa fa-stopwatch"></i>
											</td>
											<td>
												{{transfer.expectedDate | date: 'dd/MM/YYYY'}}
											</td>
											<td [appCheckPermission]="[5090]" [permissionType]="permissionType.ALL">
												{{transfer.totalCost!=null? (transfer.totalCost | currency: 'Q') : '?'}}
											</td>
											<td>
												<i [tooltip]="transfer.executed?'Ejecutada':'En espera'"
													[ngClass]="transfer.executed?'fa-circle-check check':'fa-stopwatch'"
													class="fa"></i>
											</td>
											<td>
												<i [tooltip]="!transfer.transfer?'Transformación':'Traslado'"
													[ngClass]="!transfer.transfer?'fa-arrows-rotate':'fa-people-carry-box'"
													class="fa-solid text-info"></i>
											</td>
											<td class="no-border-td option-tab" 
											[class.option-tab-error]="existDiference[transfer.id] && transfer.executed">
												<!-- <i tooltip="Ver detalles" class="fa fa-eye text-info clickeable"
													(click)="showDetails(transfer)"></i> -->
													<span (click)="showDetails(transfer)" title="Ver detalles"
														class="clickeable"
														
														>
														<i *ngIf="!detailing[transfer.id]" class="fa fa-eye"></i>
														<span *ngIf="detailing[transfer.id]"
															class="spinner-border spinner-border-sm" aria-hidden="true"></span>
													</span>

											</td>
										</tr>
									</ng-container>
									<tr class="tr-middle" *ngIf="pagination.filter.length == 0">
										<td colspan="9" style="color: gray">
											<i class="fa fa-circle-info"></i>No se encontraron facturas en las fechas
											seleccionadas
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<app-pagination-custom [elements]="pagination"></app-pagination-custom>
					</ng-container>
					<app-loading-animation *ngIf="gettingData && warehouse" [height]="'10rem'"></app-loading-animation>
				</ng-container>
				<p class="display-1 text-center text-info mt-3" *ngIf="!warehouse || !startDate || !endDate">
					<i class="fa fa-circle-info"></i> Completa los campos para obtener los registros.
				</p>
			</div>
		</div>

		<div class="row" *ngIf="summaryToggle">
			<div class="col" id="list-container" [appCheckPermission]="[5090]" [permissionType]="permissionType.ALL">
				<ng-container *ngIf="warehouse && startDate && endDate">
					<ng-container *ngIf="!gettingDataSummary">
						<div class="table-responsive mt-2" style="margin-bottom: 0;">
							<table class="table table-bordered" style="margin-bottom: 0;">
								<thead>
									<tr class="tr-middle">
										<th colspan="2"></th>
										<th colspan="5" class="bg-warning text-white">Entrada</th>
										<th colspan="5" class="bg-success text-white">Salida</th>
									</tr>
									<tr class="tr-middle title">
										<th>
											Codigo
										</th>
										<th>
											Bodega
										</th>
										<th class="bg-warning">
											Compra
										</th>
										<th class="bg-warning">
											Traslado
										</th>
										<th class="bg-warning">
											Total
										</th>
										<th class="bg-warning">
											Unidades Entrada
										</th>
										<th class="bg-warning">
											Cantidad Productos
										</th>
										<th class="bg-success">
											Venta
										</th>
										<th class="bg-success">
											Traslado
										</th>
										<th class="bg-success">
											Total
										</th>
										<th class="bg-success">
											Unidades Salida
										</th>
										<th class="bg-success">
											Cantidad Productos
										</th>
									</tr>
								</thead>
								<tbody>
									<ng-container *ngFor="let item of paginationSummary.filter">
										<tr class="tr-middle" >
											<td>
												{{item.code}}
											</td>
											<td>
												{{item.name}}
											</td>
											<td class="bg-warning-subtle">
												{{item.totalPurchases | currency: 'Q'}}
											</td>
											<td class="bg-warning-subtle">
												{{item.totalTranslateIn | currency: 'Q'}}
											</td>
											<td class="bg-warning-subtle">
												{{item.totalIn | currency: 'Q'}}
											</td>
											<td class="bg-warning-subtle text-center">
												<div class="d-flex align-items-center justify-content-center gap-2">

													<span>
														{{(item.totalQuantityIn ?? 0) | number:'1.0-2'}}
													</span>

													<button
														type="button"
														class="btn btn-sm btn-outline-warning"
														title="Ver productos de entrada"
														(click)="toggleSummaryProducts(item, 1)">

														<i
															class="fa"
															[ngClass]="
																expandedSummary?.warehouseId == item.id &&
																expandedSummary?.type == 1
																? 'fa-eye-slash'
																: 'fa-eye'
															">
														</i>

													</button>

												</div>
											</td>
											<td class="bg-warning-subtle">
												{{(item.totalProductsIn ?? 0) | number:'1.0-2'}}
											</td>
											<td class="bg-success-subtle">
												{{item.totalSales | currency: 'Q'}}
											</td>
											<td class="bg-success-subtle">
												{{item.totalTranslateOut | currency: 'Q'}}
											</td>
											<td class="bg-success-subtle text-center">
												{{item.totalOut | currency: 'Q'}}
											</td>
											<td class="bg-success-subtle text-center">
												<div class="d-flex align-items-center justify-content-center gap-2">

													<span>
														{{item.totalQuantityOut ?? 0 | number:'1.0-2'}}
													</span>

													<button
														type="button"
														class="btn btn-sm btn-outline-success"
														title="Ver productos de salida"
														(click)="toggleSummaryProducts(item, 2)">

														<i
															class="fa"
															[ngClass]="
																expandedSummary?.warehouseId == item.id &&
																expandedSummary?.type == 2
																? 'fa-eye-slash'
																: 'fa-eye'
															">
														</i>

													</button>

												</div>
											</td>
											<td class="bg-success-subtle">
												{{(item.totalProductsOut ?? 0) | number:'1.0-2'}}
											</td>
										</tr>
										<tr
											*ngIf="
												expandedSummary &&
												expandedSummary.warehouseId == item.id
											"
										>
											<td colspan="12" class="p-3 bg-light">

												<div class="card border-0 shadow-sm">

													<div
														class="card-header"
														[ngClass]="
															expandedSummary.type == 1
															? 'bg-warning-subtle'
															: 'bg-success-subtle'
														"
													>
														<div class="d-flex justify-content-between align-items-center">

															<strong>
																<i class="fa fa-boxes-stacked me-2"></i>

																Productos de
																{{expandedSummary.type == 1 ? 'Entrada' : 'Salida'}}
																- {{item.name}}

																<span
																	class="ms-2"
																	*ngIf="!loadingSummaryProducts[item.id + '-' + expandedSummary.type]
																		&& !errorSummaryProducts[item.id + '-' + expandedSummary.type]">

																	{{(summaryProducts[item.id + '-' + expandedSummary.type] || []).length}}
																	productos

																</span>
															</strong>

															<button
																type="button"
																class="btn btn-sm btn-outline-secondary"
																(click)="expandedSummary = null"
															>
																<i class="fa fa-xmark"></i>
															</button>

														</div>
													</div>

													<div class="card-body">

														<!-- CARGANDO -->
														<div
															*ngIf="
																loadingSummaryProducts[
																	item.id + '-' + expandedSummary.type
																]
															"
															class="text-center p-3"
														>
															<span class="spinner-border spinner-border-sm me-2"></span>
															Cargando productos...
														</div>

														<!-- ERROR -->
														<div
															*ngIf="
																errorSummaryProducts[
																	item.id + '-' + expandedSummary.type
																]
															"
															class="text-center text-danger p-3"
														>
															No se pudo cargar el detalle.

															<button
																class="btn btn-sm btn-outline-danger ms-2"
																(click)="toggleSummaryProducts(item, expandedSummary.type)"
															>
																Cerrar
															</button>
														</div>

														<!-- TABLA DE PRODUCTOS -->
														<ng-container
															*ngIf="
																!loadingSummaryProducts[
																	item.id + '-' + expandedSummary.type
																] &&
																!errorSummaryProducts[
																	item.id + '-' + expandedSummary.type
																]
															"
														>

															<table class="table table-sm table-bordered table-striped mb-0">

																<thead class="table-light">
																	<tr>
																		<th>Código</th>
																		<th>Producto</th>
																		<th class="text-center">Cantidad</th>
																	</tr>
																</thead>

																<tbody>

																	<tr
																		*ngFor="
																			let product of summaryProducts[
																				item.id + '-' + expandedSummary.type
																			] || []
																		"
																	>
																		<td>
																			{{product.productCode}}
																		</td>

																		<td>
																			{{product.productName}}
																		</td>

																		<td class="text-center">
																			{{product.totalQuantity | number:'1.0-2'}}
																		</td>
																	</tr>

																	<tr
																		*ngIf="
																			summaryProducts[
																				item.id + '-' + expandedSummary.type
																			]?.length === 0
																		"
																	>
																		<td colspan="3" class="text-center text-muted">
																			No se encontraron productos.
																		</td>
																	</tr>

																</tbody>

															</table>

														</ng-container>

													</div>
												</div>

											</td>
										</tr>
									</ng-container>
									<tr class="tr-middle" *ngIf="paginationSummary.filter.length == 0">
										<td colspan="12" style="color: gray">
											<i class="fa fa-circle-info"></i>No se encontraron registros
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<app-pagination-custom [elements]="paginationSummary"></app-pagination-custom>
					</ng-container>
					<app-loading-animation *ngIf="gettingDataSummary && warehouse" [height]="'10rem'"></app-loading-animation>
				</ng-container>
				<p class="display-1 text-center text-info mt-3" *ngIf="!warehouse || !startDate || !endDate">
					<i class="fa fa-circle-info"></i> Completa los campos para obtener los registros.
				</p>
			</div>
		</div>

	</div>
</div>
<app-simple-modal [title]="'Detalles del '+(showed.transfer?'traslado':'transformación')" *ngIf="showed"
	[requiredFields]="false" [max]="80" (close)="showed = null">
	<div fields>
		<div class="row">
			<div class="col field">
				<span class="val-span">
					{{showed.documentNumber}}
					<i *ngIf="!showed.documentNumber" class="fa-solid fa-file-circle-question"></i>
				</span>
				<span class="field-span">
					<b><i class="fa-solid fa-file"></i>Documento</b>
				</span>
			</div>
			<div class="col field">
				<span class="val-span">
					{{warehousesName[showed.fromWarehouse]}}
				</span>
				<span class="field-span">
					<b><i class="fa-solid fa-warehouse"></i>Origen</b>
				</span>
			</div>
			<div class="col field">
				<span class="val-span">
					{{warehousesName[showed.toWarehouse]}}
				</span>
				<span class="field-span">
					<b><i class="fa-solid fa-warehouse"></i>Destino</b>
				</span>
			</div>
			<div class="col field">
				<span class="val-span">
					{{showed.issuedDate | date: 'dd/MM/YYYY'}}
				</span>
				<span class="field-span">
					<b><i class="fa-solid fa-calendar-days"></i>Salida</b>
				</span>
			</div>
			<div class="col field">
				<span class="val-span">
					{{showed.receptionDate | date: 'dd/MM/YYYY'}}
					<i *ngIf="!showed.receptionDate" class="fa fa-stopwatch"></i>
				</span>
				<span class="field-span">
					<b><i class="fa-solid fa-calendar-days"></i>Llegada</b>
				</span>
			</div>
			<div class="col field">
				<span class="val-span">
					{{showed.expectedDate | date: 'dd/MM/YYYY'}}
				</span>
				<span class="field-span">
					<b><i class="fa-solid fa-calendar-days"></i>Esperada</b>
				</span>
			</div>
		</div>
		<div class="table-responsive mt-2" style="margin-bottom: 0;">
			<table class="table table-bordered" style="margin-bottom: 0;">
				<thead>
					<tr class="tr-middle">
						<th>
							Código
						</th>
						<th>
							Producto
						</th>
						<!--<th>
							Existencia Previa
						</th>-->
						<th>
							Enviado
						</th>
						<th>
							Recibido
						</th>
						<th [appCheckPermission]="[5090]" [permissionType]="permissionType.READ">
							Costo
						</th>
						<th>
							Comentario
						</th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let transfer of showed.details">
						<tr class="tr-middle" [class.tr-error]="transfer.quantityRequest != transfer.quantityReceived && showed.executed">
							<td>
								{{transfer.productCode}}
							</td>
							<td>
								{{transfer.productName}}
							</td>
							<!--<td>
								{{transfer.existencePrevious}}
							</td>-->
							<td>
								{{transfer.quantityRequest}}
							</td>
							<td>
								<ng-container *ngIf="showed.executed">
									{{transfer.quantityReceived}}
									<i (click)="transfer.showComment = !transfer.showComment"
										[ngClass]="transfer.showComment?'fa-comment-slash':'fa-comment'"
										*ngIf="transfer.comment" class="fa text-danger clickeable"></i>
									<p *ngIf="transfer.showComment" style="margin: 0; color: var(--bg-bs-servicios);">
										{{transfer.comment}}
									</p>
								</ng-container>
								<ng-container *ngIf="!showed.executed">
									<div class="btn-group" role="group">
										<button type="button" [class.opaque]="transfer.type && transfer.type != 'ok'"
											tooltip="Recibidos" class="btn btn-success"
											(click)="transfer.userQuantity = transfer.quantityRequest; transfer.type = 'ok';">
											<i class="fa fa-circle-check"></i>
										</button>
										<button type="button" [class.opaque]="transfer.type && transfer.type != 'miss'"
											(click)="transfer.userQuantity = 0; transfer.type = 'miss';"
											tooltip="Faltaron" class="btn btn-danger">
											<i class="fa fa-circle-xmark"></i>
										</button>
									</div>
									<div class="row" *ngIf="transfer.type == 'miss'">
										<div class="col-sm-4 form-group">
											<label for="received" class="form-label">¿Cuántos llegaron?</label>
											<input type="number" style="text-align: center;" class="form-control"
												name="received" min="0" [(ngModel)]="transfer.userQuantity"
												id="received">
										</div>
										<div class="col-sm-8 form-group">
											<label for="comment" class="form-label">Comentario </label>
											<textarea name="comment" id="comment" class="form-control"
												[(ngModel)]="transfer.comment"></textarea>
										</div>
									</div>
								</ng-container>
							</td>
							<td [appCheckPermission]="[5090]" [permissionType]="permissionType.READ">
								{{transfer.totalCost!=null? (transfer.totalCost | currency: 'Q') : '?'}}
							</td>
							<td>
								{{transfer.comment? transfer.comment : '---'}}
							</td>
						</tr>
					</ng-container>
					<tr class="tr-middle" *ngIf="pagination.filter.length == 0">
						<td colspan="9" style="color: gray">
							<i class="fa fa-circle-info"></i>No se encontraron facturas en las fechas
							seleccionadas
						</td>
					</tr>
					<tr *ngIf="gettingDataSummary">
						<td colspan="9">
							<app-loading-animation [height]="'10rem'"></app-loading-animation>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
	<div buttons *ngIf="!showed.executed">
		<app-loading-button [disabled]="!disabled() || saving" (clicked)="save()"></app-loading-button>
	</div>
</app-simple-modal>